import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { userActions } from '../../actions';
import { Modal, Button } from "react-bootstrap";
import { ForgotPassword } from './ChangePassword';

class Login extends Component {
  constructor(props) {
    super(props);
    this.props.logout();
    this.state = {
      email: '',
      forgotEmail: '',
      password: '',
      submitted: false,
      isOpen: false
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.submitLogin = this.submitLogin.bind(this);
    this.submitForgot = this.submitForgot.bind(this);

  }

  openModal = () => this.setState({ isOpen: true });
  closeModal = () => this.setState({ isOpen: false });

  componentDidMount() {
    document.body.className += "bg-log";
  }

  componentWillUnmount() {
    document.body.className = document.body.className.replace("bg-log", "");
  }

  handleInputChange(e) {
    let name = e.target.name;
    let value = e.target.value;
    this.setState({
      [name]: value
    });
  }

  submitLogin(e) {
    e.preventDefault();
    this.setState({ submitted: true });
    const { email, password } = this.state;
    if (email && password) {
      this.props.login(email, password);
    }
  }


  submitForgot(e) {
    e.preventDefault();
    this.setState({ submitted: true });
    const { forgotEmail } = this.state;
    if (forgotEmail) {
      this.props.ForgotPassword({ email: forgotEmail });
    }
  }

  render() {
    const { loggingIn } = this.props;
    const { email, password, submitted, forgotEmail } = this.state;
    return (
      <div className="log-main">
        <div className="log-logo">
          <img src="assets/images/logo.png" alt="logo" />
        </div>
        <div className="log-head">Enter your login details</div>
        <form >
          <div className="form-group login-form">
            <i className="fa fa-user"></i>
            <input
              type="text"
              className="form-control"
              placeholder="email"
              name="email"
              id="username"
              required="true"
              value={email}
              onChange={this.handleInputChange}
            />
            {submitted && !email && <div className="help-block">Email is required</div>}

          </div>
          <div className="form-group login-form">
            <i className="fa fa-lock"></i>
            <input
              type="password"
              className="form-control"
              name="password"
              id="password"
              placeholder="Password"
              value={password}
              onChange={this.handleInputChange}
            />
            {submitted && !password && <div className="help-block">Password is required</div>}

          </div>
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              value=""
              id="defaultCheck1"
            />
            <label className="form-check-label" htmlFor="defaultCheck1">
              Remember Me
            </label>
            <span
              className="set-rht"
              data-toggle="modal"
              data-target="#myModal"
            >
              <Link href="#" onClick={this.openModal}>Forgot Password?</Link>
            </span>
          </div>
          <div className="form-group sub-btn">
            <input
              type="submit"
              className="btn btn-block btn-lg"
              value="Sign in"
              onClick={this.submitLogin}
            />
          </div>
        </form>

        <Modal show={this.state.isOpen} onHide={this.closeModal} className="custom_modal">

          <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={this.closeModal}></button>
          <div className="modal-body select_plan_body">
            <div className="agent_title buytravel_title">Forgot Password</div>
            <div className="enter_email_outer">
              <label>Enter your email</label>
              <input className="select_custom selectplanselect" name="forgotEmail" placeholder="name@example.com" value={forgotEmail}
                onChange={this.handleInputChange} />
              <a className="go_btn view_plan_btn aos-item aos-init aos-animate" onClick={this.submitForgot} >Submit</a>
            </div>
          </div>

        </Modal>
      </div>
    )
  }
}

function mapState(state) {
  const { loggingIn } = state.authentication;
  return { loggingIn };
}

const actionCreators = {
  login: userActions.login,
  logout: userActions.logout,
  ForgotPassword: userActions.ForgotPassword
};

const connectedLoginPage = connect(mapState, actionCreators)(Login);
export { connectedLoginPage as Login };
